module.exports = __webpack_public_path__ + "static/images/2.a46c221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cover/02shangwu/2.jpg
// module id = 1n3p
// module chunks = 6 7